import * as React from 'react';
import { useMediaQuery } from '@mantine/hooks';

export const useDeviceIdentification = () => {
    const isMobile = useMediaQuery('(max-width: 767px)');
    const isTablet = useMediaQuery('(min-width: 767px) and (max-width: 1024px)');
    const isDesktop = useMediaQuery('(min-width: 1024px) and (max-width: 1200px)');
    const isDesktopWide = useMediaQuery('(min-width: 1200px)');
    const isDesktopExtraWide = useMediaQuery('(min-width: 1500px)');

    return { isMobile, isTablet, isDesktop, isDesktopWide, isDesktopExtraWide };
};

export default useDeviceIdentification;
